import { AutomatedExperience } from '../AutoGenerate/types/AutomatedExperience'
import { StockOptionsType } from '../../types/TemplateConfiguration'
import { StockOptionDataModel, StockOptionItem } from './types'
import { shouldUseAutomatedExperience } from '../AutoGenerate/automatedSectionUtil'
import { FeatureFlags } from '../../types/Global'

export function buildStockOptionModel(
  section: StockOptionsType,
  automatedExperience?: AutomatedExperience,
  featureFlags?: FeatureFlags | undefined
): StockOptionDataModel | null {
  if (!automatedExperience) return null
  const referenceSectionIds = section.sectionId
  const matchingSections = automatedExperience?.sections?.find(
    (section) => section.sectionId === referenceSectionIds
  )

  if (!matchingSections) return null
  const shouldUseAutomatedExperienceData = shouldUseAutomatedExperience(
    matchingSections,
    featureFlags
  )

  if (!shouldUseAutomatedExperienceData) {
    return null
  }
  return {
    title: matchingSections.header.title,
    subtitle: matchingSections.header.subtitle,
    items: matchingSections.items as StockOptionItem[],
    automationEnabled: true
  }
}
